module.exports = __webpack_public_path__ + "static/img/photo_frame.f09112ae.png";